import React from 'react'
import {Input, Table, Grid, Row, Col, Button, ButtonGroup, ProgressBar} from 'react-bootstrap'
import Icon from 'react-fa'
import axios from 'axios';
import {request} from '../helpers/request'
import {t} from '../helpers/translate.js'
import LoadingComponent from './common/LoadingComponent'
import moment from 'moment'
import ModalComponent from './common/ModalComponent';
import { isAdmin, isSchoolAdmin } from '../helpers/access';
import LimitComponent from './common/LimitComponent';
import PagerComponent from './common/PagerComponent';
import FileInputComponent from './common/FileInputComponent.js';

let config = require('config');

class Dropbox extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      filesStatus: [],
      processing: false,
      userFiles: { 'uploaded': [], 'received': [] },
      searchFiles: { 'uploaded': [], 'received': [] },
      page: this.props.location.query.page || 1,
      limit: this.props.location.query.limit || 10,
      receivedPage: this.props.location.query.receivedPage || 1,
      receivedLimit: this.props.location.query.receivedLimit || 10,
      destinationEmail: this.populateDestinationEmail(),
      errors: null,
      schoolName: '',
      description: '',
      schoolOptions: this.getModalSchoolOptions(),
      allCmsSchools: null,
      loadingText: t('Processing Request'),
      uploadPercentage: 0,
      filterFiles: '',
      filterBy: 'fileName'
    };
  }

  componentWillMount() {
    if (isAdmin()) {
      this.getAllCmsSchools();
    }
    this.getDropboxFiles(this.props.location.query);
  }

  handleFileSelection(event) {
    event.preventDefault();
    const files = event.target.files
    this.setState({filesStatus: this.getFilesArray()})
  }

  populateDestinationEmail() {
    const org = sessionStorage.getItem('org');
    if (isSchoolAdmin()) {
      return org === 'alumo' ? ['enrolmentservices@americas.msh-intl.com'] : ['admin@studyinsured.com'];
    }
    return [];
  }

  componentWillReceiveProps(newProps) {
    this.getDropboxFiles(newProps.location.query);
  }

  getFilesArray() {
    const files = [];
    Object.values(this.uploadInput.files).forEach(file => {
      const status = { filename: file.name, status: '' }
      files.push(status)
    });

    return files;
  }

  setErrorMsg(msg) {
    this.state.errors.push(msg);
    this.setState({ errors: this.state.errors });
  }

  validateReqData(data) {
    if (data.fileNames.length === 0) {
      this.setErrorMsg(t('Please select a file to upload'));
    }
    if (data.description === '') {
      this.setErrorMsg(t('Description is required'));
    }
    if (data.email.length === 0) {
      this.setErrorMsg(t('Destination Email is required'));
    }
    if (data.schoolName === '') {
      this.setErrorMsg(t('School Name is required'));
    }
    if (data.email.length > 5) {
      this.setErrorMsg(t('Please enter no more than 5 emails'));
    }
    return this.state.errors.length == 0;
  }

  setParams(query) {
    this.state.limit = query.limit || '10';
    this.state.page = query.page || '1';
    this.state.receivedLimit = query.receivedLimit || '10';
    this.state.receivedPage = query.receivedPage || '1';
  }

  handleUploads = (ev) => {
    this.state.errors = [];
    const filesStatus = this.state.filesStatus;
    const data = { fileNames: [], email: this.state.destinationEmail.map(v => v.toLowerCase()), schoolName: this.state.schoolName, description: this.state.description };

    Object.values(this.uploadInput.files).forEach(file => {
      data.fileNames.push(file.name)
    });

    if (this.validateReqData(data)) {
      filesStatus.map(file => file.status = t('Upload in Progress'))
      this.setState({ filesStatus: filesStatus })

      request(`${config.default.api}/uploadToDropbox`,
        'POST',
        data,
        function (responseData, status) {
          if (status == 200) {
            this.uploadFiles(responseData);
            this.emailInput.value = this.populateDestinationEmail();
            this.uploadInput.value = '';
            event.preventDefault();
          } else if (status == 400) {
            this.showModal(t('Error'), responseData.messages.map((message) => <p>{t(message)}</p>));
            filesStatus.map(file => file.status = '')
          } else {
            const errorMessage = responseData.messages.map((message) => <p>{t(message)}</p>);
            this.showModal(t('Error'), errorMessage);
            event.preventDefault();
          }
        }.bind(this),
        { 'Content-Type': 'application/json' }
      )
    }
  }

  getDropboxFiles(query) {
    this.setParams(query);
    this.setState({ processing: true });

    const requestBody = {
      page: this.state.page,
      limit: this.state.limit,
      receivedLimit: this.state.receivedLimit,
      receivedPage: this.state.receivedPage
    };

    request(`${config.default.api}/getDropboxFiles`,
      'POST', requestBody,
      function (responseData, status) {
        this.setState({ processing: false });
        if (status == 200) {
          this.setState({
            userFiles: responseData[0],
            searchFiles: responseData[1],
          })
          event.preventDefault();
        } else {
          this.showModal(t('Error'), responseData.messages.map((message) => <p>{message}</p>))
        }
      }.bind(this),
      { 'Content-Type': 'application/json' }
    );
  }

  showModal(title, body, resetDataOnClose = true) {
    this.setState({
      showModal: true,
      modalBody: t(body),
      modalTitle: t(title),
      resetDataOnClose: resetDataOnClose
    }
    )
  }

  handleModalClose() {
    this.setState({
      showModal: false,
    })
    this.getDropboxFiles(this.props.location.query);
  }

  uploadFiles(data) {
    Object.entries(this.uploadInput.files).forEach(([key, file]) => {
      this.uploadToS3(file, data[key])
    })
  }

  uploadToS3(file, signedRequest) {
    const filesStatus = this.state.filesStatus;
    const foundIndex = filesStatus.findIndex(x => x.filename === file.name)
    const options = {
      headers: {
        'Content-Type': 'pdf',
      },
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        const maxSize = 5 * 1024 * 1024;
        const percent = Math.floor((loaded * 100) / total);

        if (percent < 100 && (file.size > maxSize)) {
          filesStatus[foundIndex].progress = percent;
          this.setState({ uploadPercentage: percent });
        }
      }
    }

    axios.put(signedRequest, file, options)
    .then(result => {
      this.markFilesAsUploaded(file)
    })
    .catch(err => {
      this.markFilesAsFailed(file)
    })
  }

  markFilesAsUploaded(file) {
    const filesStatus = this.state.filesStatus;
    const foundIndex = filesStatus.findIndex(x => x.filename === file.name)
    filesStatus[foundIndex].status = t('Upload Complete');

    const data = { filename: file.name, filesStatus: filesStatus };
    request(`${config.default.api}/setDropboxStatus`, 'PUT', data,
      function (responseData, status) {
        if (status == 200) {
          this.setState({ uploadPercentage: 100 });
          const status = filesStatus.map(file => file.status)
          status.every((val, i, arr) => val === arr[0]) && this.getDropboxFiles(this.props.location.query);
          this.descriptionInput.value = ''
          this.setState({ destinationEmail: this.populateDestinationEmail(), schoolName: '', description: '', uploadPercentage: 0 });
        }
      }.bind(this)
    );
  }

  markFilesAsFailed(file) {
    const filesStatus = this.state.filesStatus;
    const foundIndex = filesStatus.findIndex(x => x.filename === file.name)
    filesStatus[foundIndex].status = t('Failed');

    const data = { filename: file.name, filesStatus: filesStatus }
    request(`${config.default.api}/setDropboxStatus`, 'PUT', data);
    this.setState({ filesStatus: filesStatus, processing: false })
  }

  updateDestinationEmail(e) {
    const email = e.target.value.replaceAll(' ','');
    this.setState({ destinationEmail: email.split(';') });
  }

  updateSchool(value) {
    this.setState({ schoolName: value });
  }

  getDescription(e) {
    this.setState({ description: e.target.value });
  }

  deleteFile(link) {
    this.setState({ processing: true });

    request(`${config.default.api}/deleteDropboxFile/${link}`,
      'DELETE', null,
      function (responseData, status) {
        if (status == 200) {
          this.showModal(t('Success'), t('File has been deleted'));
          this.setState({
            processing: false,
          })
        } else {
          const errorMessage = responseData.messages.map((message) => <p>{message}</p>);
          this.showModal(t('Error'), errorMessage);
        }
      }.bind(this)
    )
  }

  getS3TemporaryLink(link) {
    const succ = true;
    request(`${config.default.api}/downloadDropboxFile/${link}`,
      'GET',
      null,
      function (data, status) {
        if (status == 200) {
          if (succ) {
            window.open(data.signed_url, "_blank");
          }
        }
      }.bind(this),
      { 'Content-Type': 'application/json' }
    );
  }

  renderTableCell (value) {
    return <td>{value}</td>
  }

  checkFileExpired(file){
    return (moment().diff(file.created_at, 'days') > config.default.dropbox_expiry_days)
  }

  getModalSchoolOptions() {
    const schools = [];
    const getMultiSchools = sessionStorage.getItem('all_schools');

    const schoolList = getMultiSchools ? getMultiSchools : sessionStorage.getItem('school');

    schoolList && schoolList.split(",").forEach(function (item, index) {
      schools.push({ 'text': item, 'value': item });
    });

    return schools;
  }

  getAllCmsSchools() {
    this.setState({ loading: true });
    request(`${config.default.api}/allCmsSchools`, 'GET', null,
      function (responseData, status) {
        if (status == 200) {
          this.setState({
            allCmsSchools: responseData,
            loading: false
          });
        }
      }.bind(this)
    );
  }

  renderButtonsCell(file) {
    return <td>
      <ButtonGroup className="pull-right">
        {
          file.status == t('Upload Complete') &&
          <Button
            disabled={this.checkFileExpired(file)}
            className="btn button-primary"
            onClick={this.getS3TemporaryLink.bind(this, file.id)}
          ><Icon name="download" />
          </Button>
        }
        <Button
          className="btn button-primary"
          onClick={this.deleteFile.bind(this, file.id)}
        ><Icon name="trash" />
        </Button>
      </ButtonGroup>
    </td>
  }

  renderAttachments (files){
    return (
      <tbody>
      {files.map(
        (attachment, index) => {
          const target = attachment.recipient || attachment.sender;
          const expiry_date = moment(attachment.created_at).add(config.default.dropbox_expiry_days, 'days').format("YYYY-MM-DD")
          return (
            <tr key={index}>
              {this.renderTableCell(attachment.filename)}
              {this.renderTableCell(attachment.description)}
              {this.renderTableCell(`${target.first_name} ${target.last_name} - ${target.email}`)}
              {this.renderTableCell(attachment.created_at)}
              {this.renderButtonsCell(attachment)}
              {this.renderTableCell(expiry_date)}
            </tr>
          )
        })}
      </tbody>
    )
  }

  getOptions() {
    const options = isAdmin() ? this.state.allCmsSchools : this.state.schoolOptions;

    options.sort(function (a, b) {
      return a.value.localeCompare(b.value);
    });

    return options;
  }

  getUploadedPager(userFiles) {
    return !this.state.filterFiles && <div className="col-sm-12 div-center">
      <PagerComponent page={this.state.page} limit={this.state.limit} total={userFiles.total_uploaded} />
    </div>
  }

  getReceivedPager(userFiles) {
    return !this.state.filterFiles && <div className="col-sm-12 div-center">
      <PagerComponent receivedPage={this.state.receivedPage} limit={this.state.receivedLimit} total={userFiles.total_received} />
    </div>
  }

  showTextFilter() {
    return <div className='filter-files'>
      <Input
        className="col-sm-3"
        type="select"
        value={this.state.filterBy}
        onChange={(event) => { this.setState({ filterBy: event.target.value }) }}
      >
        <option value='fileName'>{t('File Name')}</option>
        <option value='email'>{t('Email Address')}</option>
        <option value='description'>{t('Description')}</option>
      </Input>
      <Input
        className="col-sm-9"
        type='text'
        placeholder={t('Search Files...')}
        defaultValue={this.state.filterFiles || ''}
        onChange={(event) => { this.setState({ filterFiles: event.target.value }) }}
      />
    </div>
  }

  render() {
    const tableHeadUploaded = [
      { title: t('File Name'), width: 3 },
      { title: t('Description'), width: 2 },
      { title: t('Recipient'), width: 3 },
      { title: t('Date/Time'), width: 2 },
      { title: t('Action'), width: 1 },
      { title: t('Expiry Date'), width: 2 },
    ];

    const tableHeadReceived = [
      { title: t('File Name'), width: 3 },
      { title: t('Description'), width: 2 },
      { title: t('Uploader'), width: 3 },
      { title: t('Date/Time'), width: 2 },
      { title: t('Action'), width: 1 },
      { title: t('Expiry Date'), width: 2 },
    ];

    const userFiles = this.state.userFiles;
    const filterFiles = this.state.filterFiles;
    const filterBy = this.state.filterBy;
    const filterUploaded = this.state.searchFiles.uploaded.filter((file) => ((filterBy === 'fileName') ? file.filename : (filterBy === 'email') ? file.recipient.email : file.description).toLowerCase().includes(filterFiles.toLowerCase()));
    const filterReceived = this.state.searchFiles.received.filter((file) => ((filterBy === 'fileName') ? file.filename : (filterBy === 'email') ? file.sender.email : file.description).toLowerCase().includes(filterFiles.toLowerCase()));
    const renderUploaded = filterFiles ? filterUploaded : userFiles.uploaded;
    const renderReceived = filterFiles ? filterReceived : userFiles.received;

    return (<div className="container">
    	<h2 className='page-title row div-center'>{t('File Exchange')}</h2>
    	<br />

      {
        <div className='section_container'>
          <h4 className="div-center"><b>{t('Upload Files')}</b></h4>
          <FileInputComponent
            onUpload={this.handleFileSelection.bind(this)}
            inputRef={(ref) => { this.uploadInput = ref; }}
          />
          <h4 className="div-center">{t('Files to Upload')}</h4>
          <Grid fluid>
          {this.state.filesStatus.map((file, index) => {
            return (
              <Row className="mt-4" key={index}>
                  <Col sm={6}>{file.filename}</Col>
                  {this.state.uploadPercentage > 0 && file.progress !== undefined ?
                    <Col sm={6}>
                      <ProgressBar now={file.progress} active label={`${file.progress}%`} />
                    </Col> :
                    <Col sm={6}>{file.status}</Col>
                  }
              </Row>
            )
              })}
          </Grid>
          <br />
          <h4 className="div-center">{t('Description')}</h4>
          <input
            className='form-control'
            placeholder='Description'
            type='text'
            onChange={this.getDescription.bind(this)}
            ref={(ref) => { this.descriptionInput = ref; }}
          />
          <br />
          <h4 className="div-center">{t('Destination Email')}</h4>
          <input
            className='form-control'
            placeholder={t('Destination Email')}
            type='text'
            disabled={isSchoolAdmin()}
            value={this.state.destinationEmail.join(';')}
            onChange={this.updateDestinationEmail.bind(this)}
            ref={(ref) => { this.emailInput = ref; }}
          />
          <br />
          <h4 className="div-center">{t('School Name')}</h4>
          {!this.state.loading && <Input
            type="select"
            value={this.state.schoolName}
            onChange={(event) => { this.updateSchool(event.target.value) }}
          >
            {<option key={-1} disabled value="">---</option>}
            {this.getOptions().map((item, i) => <option key={i} value={item.value}>{t(item.text)}</option>)}
          </Input>}
          {(this.state.errors) &&
            <ul className='error-message'>
              {this.state.errors.map((error) => <li>{error}</li>)}
            </ul>}
          <br />
          <div className="div-center">
            <button
              className="btn button-secondary"
              onClick={this.handleUploads.bind(this)}
            >
            {t('Upload Files')}
            </button>
          </div>
        </div>
      }

      <div className='section_container row'>
        {this.showTextFilter()}
        {
          <div>
            <h4 className="div-center"><b>{t('Uploaded Files')}</b></h4>
            <div className="row">
              <div className="col-sm-9">
                <div className="form-control-static"><b>{t('Number of Results:')} {filterFiles ? filterUploaded.length : userFiles.total_uploaded}</b></div>
              </div>
              {!filterFiles && <div className="col-sm-3"><LimitComponent currentLimit={this.state.limit}
                /></div>}
              {this.getUploadedPager(userFiles)}
            </div>
            <br />
            <Table striped condensed hover id='uploadedTable'>
              <thead>
                <tr>
                  {tableHeadUploaded.map((col, index) => <th className={`col-sm-${col.width}`} key={index}>{t(col.title)}</th>)}
                </tr>
              </thead>
              {this.renderAttachments(renderUploaded)}
            </Table>
            {this.getUploadedPager(userFiles)}
          </div>
        }
      </div>

      <div className='section_container row'>
        {
          <div>
            <h4 className="div-center"><b>{t('Received Files')}</b></h4>
            <div className="row">
              <div className="col-sm-9">
                <div className="form-control-static"><b>{t('Number of Results:')} {filterFiles ? filterReceived.length : userFiles.total_received}</b></div>
              </div>
              {!filterFiles && <div className="col-sm-3"><LimitComponent receivedLimit={this.state.receivedLimit}
              /></div>}
              {this.getReceivedPager(userFiles)}
            </div>
            <br />
            <Table striped condensed hover id='uploadedTable'>
              <thead>
                <tr>
                  {tableHeadReceived.map((col, index) => <th className={`col-sm-${col.width}`} key={index}>{t(col.title)}</th>)}
                </tr>
              </thead>
              {this.renderAttachments(renderReceived)}
            </Table>
            {this.getReceivedPager(userFiles)}
          </div>
        }
      </div>

      <ModalComponent
        title={this.state.modalTitle}
        body={this.state.modalBody}
        onClose={this.handleModalClose.bind(this)}
        show={this.state.showModal}
        resetDataOnClose={this.state.resetDataOnClose}
      />

	    <LoadingComponent show={this.state.processing} text={this.state.loadingText}/>
      </div>
    )
  }
}
Dropbox.displayName = 'Dropbox';
export default Dropbox;



// WEBPACK FOOTER //
// ./src/components/Dropbox.js